module.exports = __webpack_public_path__ + "static/media/Madfit_Website_01.66c57442.jpg";